import { IconButton, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import SalaryIncreaseConfigFields from "./SalaryIncreaseConfigFields";
import { ToggleContainer } from "../styles";
import KtaIncreaseConfigFields from "./KtaIncreaseConfigFields";

type Props = {
  index: number;
  title: string;
  handleOpen: (salaryComponent: string) => void;
  open: boolean;
  salaryComponent: string;
  margin?: boolean;
  ktaMode: boolean;
  /**
   * The base name of the field to be watched (in ktaMode)
   */
  ktaBase?: string;
};

const SalaryIncreaseConfigToggle = ({
  index,
  title,
  handleOpen,
  open,
  salaryComponent,
  margin,
                                      ktaMode = false,
                                      ktaBase = ""
}: Props) => (
  <>
    <ToggleContainer onClick={() => handleOpen(salaryComponent)}>
      <Typography variant="header" fontWeight={500} fontSize="18px">
        {title}
      </Typography>
      <IconButton size="small">
        {open ? <ExpandLess /> : <ExpandMore />}
      </IconButton>
    </ToggleContainer>
    {ktaMode && <KtaIncreaseConfigFields index={index} open={open} margin={margin} componentBase={ktaBase}/>}
    {!ktaMode && <SalaryIncreaseConfigFields index={index} open={open} margin={margin}/>}
  </>
);

export default SalaryIncreaseConfigToggle;
